import request from '@/utils/request'

export const API_LOGIN_CAPTCHA='/api/cmdb-template/auth/captcha'
export const API_LOGIN_SMSCODE='/api/cmdb-template/auth/sms'
export const API_LOGIN_LOGIN='/api/cmdb-template/auth/login'
export const API_LOGIN_PASSWORD='/api/cmdb-template/sys-user/change-pwd'
export const API_CHANGE_TENANT='/api/cmdb-template/auth/change'
export const API_LOGIN_QR_CODE='/api/cmdb-template/auth/qr-code'

// 图形验证码
export function getCaptcha () {
  return request({
    url: API_LOGIN_CAPTCHA,
    method: "GET",
    responseType: "blob"
  })
}


export function getQrCode () {
  return request({
    url: API_LOGIN_QR_CODE,
    method: "GET",
    responseType: "blob"
  })
}

// 图形验证码
export function getSmsCode (phone:string) {
  return request({
    url: API_LOGIN_SMSCODE,
    method: "GET",
    params: {
      phone
    }
  })
}


export function goLogin (data:any) {
  return request({
    url: API_LOGIN_LOGIN,
    method: "POST",
    data
  })
}

export function changePwd (data:any) {
  return request({
    url: API_LOGIN_PASSWORD,
    method: "POST",
    data
  })
}
export function changeTenant (data:any) {
  return request({
    url: API_CHANGE_TENANT + '?tenantCode=' + data.tenantCode,
    method: "GET",
    data
  })
}
